import type { Shape } from "../types";

/** Couleurs et bordure résolues d'une forme, normales et au survol — voir `resolveShapeVisualProps`. */
export interface HoverAwareVisualProps {
  bgColor: string;
  borderColor: string;
  borderWidth: number;
  hoverBgColor: string;
  hoverBorderColor: string;
  hoverBorderWidth: number;
  borderWidthUnit?: "px" | "m";
  hoverBorderWidthUnit?: "px" | "m";
  borderIsDefault: boolean;
  borderDashed: boolean;
}

/**
 * Pour une forme en aperçu de survol (voir `setHoverPreviewShapes`), affiche ses couleurs et sa bordure
 * de survol à la place des normales. Une bordure de survol choisie n'est plus « la bordure par défaut ».
 */
export function hoverPreviewVisualProps<T extends HoverAwareVisualProps>(
  props: T,
  shape: Shape,
  hoverPreviewIds: ReadonlySet<string>,
): T {
  if (!hoverPreviewIds.has(String(shape.id))) return props;

  return {
    ...props,
    bgColor: props.hoverBgColor,
    borderColor: props.hoverBorderColor,
    borderWidth: props.hoverBorderWidth,
    borderWidthUnit: props.hoverBorderWidthUnit,
    borderIsDefault: props.borderIsDefault && shape.hoverStyle?.borderColor === undefined,
    borderDashed: shape.hoverStyle?.borderDashed ?? props.borderDashed,
  };
}
